import { withInstall } from '@tav-ui/utils/with-install'
import BasicHelp from './src/basic-help'
const TaBasicHelp = withInstall(BasicHelp)
export { TaBasicHelp }
export default TaBasicHelp
export * from './src/types'
